import React, { useState } from 'react';
import { Box, Button, Typography, IconButton, Menu, MenuItem, Grid } from '@mui/material';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

const NavigationLayout = () => {
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [selectedButton,setSelectedButton]=useState("")

  const handleCalendarClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCalendarClose = () => {
    setAnchorEl(null);
  };

  const handleDateChange = (date) => {
    setSelectedDate(date);
    handleCalendarClose();
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', p: 2, borderBottom: '1px solid #ddd' }}>
      {/* Date Navigation */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <IconButton>
          <ArrowBackIosNewIcon />
        </IconButton>
        <Typography variant="h6">{selectedDate.toDateString()}</Typography>
        <IconButton>
          <ArrowForwardIosIcon />
        </IconButton>
      </Box>

      {/* View Options */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <Button  variant={selectedButton=="day"?"contained":"text"} onClick={e=>setSelectedButton("day")}>Day</Button>
        <Button variant={selectedButton=="week"?"contained":"text"} onClick={e=>setSelectedButton("week")}>Week</Button>
        <Button variant={selectedButton=="month"?"contained":"text"} onClick={e=>setSelectedButton("month")}>Month</Button>
        <Button variant={selectedButton=="quator"?"contained":"text"} onClick={e=>setSelectedButton("quator")}>Quarter</Button>
        <Button>Custom</Button>
      </Box>

      {/* Custom Calendar */}
      <Box>
        <Button
          startIcon={<CalendarMonthIcon />}
          variant="outlined"
          onClick={handleCalendarClick}
        >
          Select Date
        </Button>
        <Menu anchorEl={anchorEl} open={open} onClose={handleCalendarClose}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              views={['year', 'month', 'day']}
              value={selectedDate}
              onChange={handleDateChange}
              renderInput={({ inputRef, inputProps }) => (
                <Box sx={{ p: 2 }}>
                  <input ref={inputRef} {...inputProps} style={{ display: 'none' }} />
                </Box>
              )}
            />
          </LocalizationProvider>
          <Box sx={{ textAlign: 'center', p: 2 }}>
            <Button onClick={handleCalendarClose}>Cancel</Button>
            <Button onClick={handleCalendarClose} color="primary">Done</Button>
          </Box>
        </Menu>
      </Box>

      {/* Search Bar */}
      <Box>
        <input
          type="text"
          placeholder="Search by company name or mobile number"
          style={{
            padding: '8px 12px',
            border: '1px solid #ddd',
            borderRadius: '4px',
            width: '300px',
          }}
        />
      </Box>
    </Box>
  );
};

export default NavigationLayout;
